module.exports = __webpack_public_path__ + "arrow-down-34b036f46bdc37144746.svg";